import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { IJourneyComparisonRow } from '../../types/IDifferenceChecker';
import { setFilters, resetFilters } from './differenceCheckerFiltersSlice';

interface DifferenceCheckerState {
  selectedRecord: IJourneyComparisonRow | null;
  listDisplayedData: IJourneyComparisonRow[];
  isScheduleComparisonUpdateAvailable: boolean;
  scheduleComparisonUpdateGeneration: number;
  scheduleComparisonUpdateReceivedAt: number | null;
}

const initialState: DifferenceCheckerState = {
  selectedRecord: null,
  listDisplayedData: [],
  isScheduleComparisonUpdateAvailable: false,
  scheduleComparisonUpdateGeneration: 0,
  scheduleComparisonUpdateReceivedAt: null,
};

const differenceCheckerSlice = createSlice({
  name: 'differenceChecker',
  initialState,
  reducers: {
    setSelectedRecord(state, action: PayloadAction<IJourneyComparisonRow>) {
      state.selectedRecord = action.payload;
    },
    clearSelectedRecord(state) {
      state.selectedRecord = null;
    },
    setListDisplayedData(
      state,
      action: PayloadAction<IJourneyComparisonRow[]>
    ) {
      state.listDisplayedData = action.payload;
    },
    scheduleComparisonUpdateReceived(
      state,
      action: PayloadAction<{ receivedAt: number }>
    ) {
      state.isScheduleComparisonUpdateAvailable = true;
      state.scheduleComparisonUpdateGeneration += 1;
      state.scheduleComparisonUpdateReceivedAt = action.payload.receivedAt;
    },
    acknowledgeScheduleComparisonUpdate(
      state,
      action: PayloadAction<{ generation: number }>
    ) {
      if (
        action.payload.generation !== state.scheduleComparisonUpdateGeneration
      ) {
        return;
      }

      state.isScheduleComparisonUpdateAvailable = false;
      state.scheduleComparisonUpdateReceivedAt = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setFilters, (state) => {
        state.selectedRecord = null;
        state.listDisplayedData = [];
      })
      .addCase(resetFilters, (state) => {
        state.selectedRecord = null;
        state.listDisplayedData = [];
      });
  },
});

export const {
  setSelectedRecord,
  clearSelectedRecord,
  setListDisplayedData,
  scheduleComparisonUpdateReceived,
  acknowledgeScheduleComparisonUpdate,
} = differenceCheckerSlice.actions;

export default differenceCheckerSlice.reducer;
